import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { themeSettings } from "./theme";
import { Provider, useSelector } from "react-redux";
import { useMemo } from "react";
import { RootState, store } from "state";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useRoutes,
} from "react-router-dom";
import Dashboard from "scenes/dashboard";
import Layout from "scenes/layout";
import LoginButton from "components/LoginButton";
import LogoutButton from "components/LogoutButton";
import Profile from "scenes/profile";
import useAuthListener from "components/auth/useAuthListener";
import LoginPage from "scenes/login";
import ProtectedRoute from "components/protectedRoute";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "state/api";
import StudentsPage from "scenes/students";
import StudentDetailPage from "scenes/studentDetail";
import StudentReportPage from "scenes/studentReport";
import ProfessionalsPage from "scenes/Professionals";
import AdminPage from "scenes/admin";
import { elements } from "chart.js";
import AdminDashboard from "scenes/adminDashboard";

function App() {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN as string;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID as string;

  return (
    <div className="app">
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: process.env.REACT_APP_REDIRECT_URI,
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email",
        }}
      >
        <Provider store={store}>
          {/* <ThemeProvider theme={theme}>
            <CssBaseline /> */}
          <AppContent />
          {/* <Routes> */}
          {/* <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Route> */}
          {/* </Routes> */}
          {/* </ThemeProvider> */}
        </Provider>
      </Auth0Provider>
    </div>
  );
}

function AppContent() {
  useAuthListener();
  const { isAuthenticated, isLoading } = useAuth0();
  const mode = useSelector((state: RootState) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const routeArray = [
    {
      path: "*",
      element: <LoginPage />,
    },
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute
          auth={{ isAuthenticated: isAuthenticated, isLoading: isLoading }}
        >
          <Dashboard />
        </ProtectedRoute>
      ),
    },
    {
      path: "/students",
      element: (
        <ProtectedRoute
          auth={{ isAuthenticated: isAuthenticated, isLoading: isLoading }}
        >
          <StudentsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/studentDetail/:id",
      element: (
        <ProtectedRoute
          auth={{ isAuthenticated: isAuthenticated, isLoading: isLoading }}
        >
          <StudentDetailPage />
        </ProtectedRoute>
      ),
      },
      {
          path: "/studentReport/:id",
          element: (
              <ProtectedRoute
                  auth={{ isAuthenticated: isAuthenticated, isLoading: isLoading }}
              >
                  <StudentReportPage />
              </ProtectedRoute>
          ),
      },
      {
          path: "/professionals",
          element: (
              <ProtectedRoute
                  auth={{ isAuthenticated: isAuthenticated, isLoading: isLoading }}
              >
                  <ProfessionalsPage/>
              </ProtectedRoute>
          ),
      },
    {
      path: "/admin",
      element: (
        <ProtectedRoute
          auth={{ isAuthenticated: isAuthenticated, isLoading: isLoading }}
        >
          <AdminPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/admindashboard",
      element: (
        <ProtectedRoute
          auth={{ isAuthenticated: isAuthenticated, isLoading: isLoading }}
        >
          {" "}
          <AdminDashboard />
        </ProtectedRoute>
      ),
    },
  ];
  const routeElement = useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: routeArray,
    },
  ]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {routeElement}
    </ThemeProvider>
  );
}

export default App;
